import { useContext } from 'react';
import { EpidemiologyChartsDataContext } from '../contexts/EpidemiologyChartsDataContext';

export const useEpidemiologyChartsDataContext = () => {
    return useContext(EpidemiologyChartsDataContext);
};
